module.exports = "<div class=\"errors\">\r\n    <h4 class=\"errors-title\">{{ numErrors }} ERRORS</h4>\r\n    <div class=\"error-markers\">\r\n        <span *ngFor=\"let err of errorObjs\">\r\n            <span *ngIf=\"err.error\" class=\"error-marker error-true\"></span>\r\n            <span *ngIf=\"!err.error\" class=\"error-marker error-false\"></span>\r\n        </span>\r\n    </div>\r\n    <p class=\"name\">{{ title }}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stats/errors/errors.component.html
// module id = ./src/app/components/stats/errors/errors.component.html
// module chunks = main